export default class AdminUsers {
  constructor(){}

  index(){
    new N2Styles.searchBar({
      safeContainer: '.js-table-search',
      showSelector: '.show-table-search',
      visible: true
    });
  }
}
